import { getEvent } from '~/util/getEvents';
import actions from './actions';

const fetchMatchup = (leagueSlug, eventId) => dispatch => {
  // TODO - implement caching
  dispatch(actions.fetchMatchupInitiated());
  return getEvent(leagueSlug, eventId)
    .then(response => {
      dispatch(actions.fetchMatchupSucceeded(response.json));
      return {};
    })
    .catch(error => {
      dispatch(actions.fetchMatchupFailed(error));
      return { status: 'FAILURE', statusCode: 404 };
    });
};

export default {
  fetchMatchup,
};
